import Form from "../components/FlightSearchForm";

export default function HomePage() {
    return <Form />;
}
